import * as Constant from './constant/';
import * as Setting from './setting';
export default { Constant: Constant, Setting: Setting };



//////////////////
// WEBPACK FOOTER
// ./src/app/core/index.ts
// module id = 1276
// module chunks = 0